import React, { useState, useEffect } from "react";
import { Button, Checkbox } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
const DivisionWiseTable = (props: any) => {
	const [limit, setLimit] = React.useState(10);
	const tableData = props.data;

	const removeLeadingZero = (n: any) => {
		let newStr = n?.replace(/^0+/, "");
		return newStr;
	};

	return (
		<>
			<table
				className="common-table-ui pricing-rhs-table h-[95%] !text-[0.50vw]"
				style={{
					borderTop: "1px solid #bebebe",
					borderLeft: "1px solid #bebebe",
				}}
			>
				<thead>
					<tr>
						<th className="w-[75%]">Item</th>
						<th className="w-[25%]">
							Item ID - {removeLeadingZero(tableData?.SKU)}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Volume</td>
						<td>{numberFormatter(tableData?.quantity)}</td>
					</tr>
					<tr>
						<td>Current Price ($)</td>
						<td>{numberFormatter(tableData?.price, 2, "$")}</td>
					</tr>
					<tr>
						<td>Target Price ($)</td>
						<td>
							{numberFormatter(tableData?.peer_price, 2, "$")}
						</td>
					</tr>
					<tr>
						<td>Floor Price ($)</td>
						<td>
							{numberFormatter(tableData?.FloorPrice, 2, "$")}
						</td>
					</tr>
					<tr>
						<td>Total Transactions</td>
						<td>{tableData?.totalTransactions}</td>
					</tr>
					<tr>
						<td>{`# Transactions > Target`}</td>
						<td>{tableData?.transactionsGreaterThanTarget}</td>
					</tr>
					<tr>
						<td>{`# Transactions < Floor`}</td>
						<td>{tableData?.transactionslessThanFloor}</td>
					</tr>
					<tr>
						<td>Opportunity</td>
						<td>
							{numberFormatter(
								tableData?.projectedOpportunity,
								2,
								"$"
							)}
						</td>
					</tr>
					{/* <tr>
            <td>Adjusted Price ($)</td>
            <td>
              ${" "}
              <input
                type="text"
                className="adjustedPriceInput"
                onInput={(e) => {
                  validateNumbers(e);
                }}
                defaultValue={0}
                onChange={(e) => {}}
              />
            </td>
          </tr> */}
					{/* <tr>
            <td>Accept</td>
            <td>
              <Checkbox color="green"></Checkbox>
            </td>
          </tr> */}
				</tbody>
			</table>
			{/* <Button className="saveButton float-right mt-[.5vh]" onClick={() => {}}>
        Save
      </Button> */}
		</>
	);
};
export default DivisionWiseTable;
